import script from "./SmsContentTextarea.vue?vue&type=script&setup=true&lang=js"
export * from "./SmsContentTextarea.vue?vue&type=script&setup=true&lang=js"

import "./SmsContentTextarea.vue?vue&type=style&index=0&id=0e1b7695&scoped=true&lang=css"

import exportComponent from "E:\\WebstormProjects\\sms-transfer-h5\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e1b7695"]])

export default __exports__